// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.out-of-hours-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--bg-body, #f1f5f9);
  padding: 20px;
}

.out-of-hours-card {
  background: var(--bg-card, #ffffff);
  border-radius: 16px;
  padding: 48px;
  max-width: 500px;
  width: 100%;
  text-align: center;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);
  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.05));
}

.out-of-hours-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;
  background: rgba(59, 130, 246, 0.1);
  color: #3b82f6;
}

.out-of-hours-title {
  font-size: 2rem;
  font-weight: 700;
  color: var(--text-color, #1e293b);
  margin: 0 0 16px;
}

.out-of-hours-message {
  color: var(--text-secondary, #475569);
  font-size: 1.1rem;
  line-height: 1.6;
  margin: 0 0 24px;
}

.out-of-hours-schedule {
  background: var(--bg-subtle, #f8fafc);
  border: 1px solid var(--border-color, #e2e8f0);
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 32px;
}

.out-of-hours-schedule p {
  margin: 8px 0;
  font-weight: 500;
  color: var(--text-color, #1e293b);
}

.out-of-hours-actions {
  display: flex;
  justify-content: center;
}

.out-of-hours-actions .btn-primary {
  padding: 12px 24px;
  font-weight: 600;
  font-size: 1rem;
  border-radius: 8px;
  transition: all 0.2s ease;
}
`, "",{"version":3,"sources":["webpack://./src/pages/OutofHoursPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,2CAA2C;EAC3C,0DAA0D;AAC5D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,8CAA8C;EAC9C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B","sourcesContent":[".out-of-hours-container {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--bg-body, #f1f5f9);\n  padding: 20px;\n}\n\n.out-of-hours-card {\n  background: var(--bg-card, #ffffff);\n  border-radius: 16px;\n  padding: 48px;\n  max-width: 500px;\n  width: 100%;\n  text-align: center;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);\n  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.05));\n}\n\n.out-of-hours-icon {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 24px;\n  background: rgba(59, 130, 246, 0.1);\n  color: #3b82f6;\n}\n\n.out-of-hours-title {\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--text-color, #1e293b);\n  margin: 0 0 16px;\n}\n\n.out-of-hours-message {\n  color: var(--text-secondary, #475569);\n  font-size: 1.1rem;\n  line-height: 1.6;\n  margin: 0 0 24px;\n}\n\n.out-of-hours-schedule {\n  background: var(--bg-subtle, #f8fafc);\n  border: 1px solid var(--border-color, #e2e8f0);\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 32px;\n}\n\n.out-of-hours-schedule p {\n  margin: 8px 0;\n  font-weight: 500;\n  color: var(--text-color, #1e293b);\n}\n\n.out-of-hours-actions {\n  display: flex;\n  justify-content: center;\n}\n\n.out-of-hours-actions .btn-primary {\n  padding: 12px 24px;\n  font-weight: 600;\n  font-size: 1rem;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
